"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimmedMean = exports.setClockDrift = exports.SlavePlayback = exports.MasterPlayback = void 0;
const timecodeUtils_1 = require("./timecodeUtils");
const types_1 = require("./types");
const video_preloader_1 = __importDefault(require("../../utils/video-preloader"));
const messageBroker_1 = __importDefault(require("../../general/messageBroker"));
class MasterPlayback {
    constructor(commandsManager) {
        // all latencies are in seconds (can be decimals)
        // latency with protools, this is calibrated with the video visually.
        this.ptLatency = 0;
        // innate latency for the audio route
        this.audioRouteLatency = 0; // set thru a selector
        // Talent latency is an additional knob given to the host
        this.talentLatency = 0; // set thru a selector in the interface host
        this.baseTimecode = (0, types_1.newTimecode)(0, 0, 0, 0, 30);
        this.clipDuration = 0;
        this.currentTimecode = (0, types_1.newTimecode)(0, 0, 0, 0, 30);
        this.currentTime = 0;
        this.CLOCK_DIFF = 0; // clock diff is in milliseconds
        this.playTimeout = null;
        this.bypassLatency = false;
        this.commandsManager = commandsManager;
        this.commandsManager
            .registerNewCommand("anywhere--set_delay", console.log)
            .registerNewCommand("start_calibration", console.log)
            .registerNewCommand("loadSharedVideo", console.log)
            .registerNewCommand("anywhere--playback-goto", console.log)
            .registerNewCommand("anywhere--playback-play", console.log)
            .registerNewCommand("anywhere--playback-pause", console.log);
    }
    static getInstance(commandsManager) {
        if (!MasterPlayback.instance) {
            MasterPlayback.instance = new MasterPlayback(commandsManager);
        }
        return MasterPlayback.instance;
    }
    setClockDiff(clockDiff) {
        this.CLOCK_DIFF = clockDiff;
    }
    setBaseTimecode(timecode) {
        this.baseTimecode = timecode;
    }
    setClipDuration(duration) {
        this.clipDuration = duration;
    }
    setPTLatency(latency) {
        let oldLatency = this.ptLatency;
        this.ptLatency = latency;
        // move currentTime
        const video = document.querySelector("#sharedVideo");
        video.currentTime = video.currentTime + (latency - oldLatency);
    }
    setAudioRouteLatency(latency) {
        this.audioRouteLatency = latency;
    }
    setTalentLatency(latency) {
        this.talentLatency = latency;
    }
    setBypassLatency(bypassLatency) {
        this.bypassLatency = bypassLatency;
    }
    jumpToTimecode(timecode) {
        let t = (0, timecodeUtils_1.timecodeToSeconds)(timecode);
        let base = (0, timecodeUtils_1.timecodeToSeconds)(this.baseTimecode);
        // jump forward
        let diff = t - base;
        if (diff >= 0 && (diff < this.clipDuration || this.clipDuration == 0)) {
            const video = document.querySelector("#sharedVideo");
            video.currentTime = diff + this.ptLatency;
            this.currentTime = diff;
            // tell peers to go to
            this.sendGoToCommand();
        }
        else {
            this.currentTime = diff;
        }
    }
    play() {
        // tell peers to play in the future (or now)
        this.sendPlayCommand();
        const video = document.querySelector("#sharedVideo");
        if (this.currentTime >= 0 &&
            (this.currentTime < this.clipDuration || this.clipDuration == 0)) {
            // Should play now
            console.log("playing now");
            let playPromise = video.play();
        }
        console.log("not playing now", this.currentTime, this.clipDuration);
        // should play in a few seconds
        if (this.currentTime < 0) {
            console.log("Should play in a few seconds");
            if (this.playTimeout) {
                clearTimeout(this.playTimeout);
            }
            this.playTimeout = window.setTimeout(() => {
                let playPromise = video.play();
            }, -this.currentTime * 1000);
        }
        if (this.currentTime > this.clipDuration) {
            // Playback is beyond the length of the clip so do not play
            console.log("Playback is beyond the length of the clip");
        }
    }
    pause() {
        // tell peers to pause the video
        this.sendPauseCommand();
        const video = document.querySelector("#sharedVideo");
        video.pause();
    }
    // return the latency in the host setup in seconds
    hostLatency() {
        // the latency is composed of
        // - PTLatency: the latency in the MIDI interface between the pro-tools playback
        //              and the playback on chrome
        //
        // - audioRouteLatency: the latency of the audio route, that is the virtual audio cable
        //                     that goes from chrome to protools
        // - talent latency: an extra latency we add, this is a knob that the host can adjust
        return this.ptLatency + this.audioRouteLatency + this.talentLatency;
    }
    sendGoToCommand() {
        this.commandsManager.sendAllCommand("anywhere--playback-goto", {
            seconds: this.currentTime,
            latency: this.hostLatency(),
            bypass_latency: this.bypassLatency,
            timestamp: Date.now() + this.CLOCK_DIFF,
        });
    }
    sendPlayCommand() {
        this.commandsManager.sendAllCommand("anywhere--playback-play", {
            seconds: this.currentTime,
            latency: this.hostLatency(),
            bypass_latency: this.bypassLatency,
            timestamp: Date.now() + this.CLOCK_DIFF,
        });
    }
    sendPauseCommand() {
        this.commandsManager.sendAllCommand("anywhere--playback-pause", {
            seconds: this.currentTime,
            latency: this.hostLatency(),
            bypass_latency: this.bypassLatency,
            timestamp: Date.now() + this.CLOCK_DIFF,
        });
    }
    removeSharedVideo() { }
    loadSharedVideo() { }
    sendCurrentGoTo() {
        const sharedVideo = document.querySelector("#sharedVideo");
        this.currentTime = sharedVideo === null || sharedVideo === void 0 ? void 0 : sharedVideo.currentTime;
        this.sendGoToCommand();
    }
    setLocalVideoListeners() {
        let sharedVideo = document.getElementById("sharedVideo");
        // set shared video events
        sharedVideo.onplay = () => {
            this.currentTime = sharedVideo.currentTime;
            // send the command to other peers
            this.sendPlayCommand();
            // After a second lets send a GoTo command to make sure everyone is in sync
            window.setTimeout(() => {
                this.currentTime = sharedVideo.currentTime;
                this.sendGoToCommand();
            }, 1000);
        };
        sharedVideo.onpause = () => {
            // send the command to peers
            this.currentTime = sharedVideo.currentTime;
            this.sendPauseCommand();
        };
        sharedVideo.onseeked = (e) => {
            this.currentTime = sharedVideo.currentTime;
            // send goto command to peers
            this.sendGoToCommand();
        };
    }
}
exports.MasterPlayback = MasterPlayback;
class SlavePlayback {
    constructor(role, commandsManager, videoElem, myId) {
        this.voiceLatencyWithHostInMs = 0; // latency is in milliseconds
        this.CLOCK_DIFF_IN_MS = 0;
        this.myId = "";
        this.playbackTimeout = null;
        this.playLatencies = [0.2]; // in seconds
        this.currentURL = "";
        this.role = role;
        this.videoElem = videoElem;
        this.myId = myId;
        commandsManager
            .registerNewCommand("anywhere--set_delay", (data) => {
            this.voiceLatencyWithHostInMs += data.args;
        })
            .registerNewCommand("start_calibration", this.handleStartCalibration.bind(this))
            .registerNewCommand("loadSharedVideo", this.handleLoadSharedVideo.bind(this))
            .registerNewCommand("anywhere--playback-goto", this.handleRemoteGoTo.bind(this))
            .registerNewCommand("anywhere--playback-play", this.handleRemotePlay.bind(this))
            .registerNewCommand("anywhere--playback-pause", this.handleRemotePause.bind(this));
    }
    setClockDiff(clockDiff) {
        this.CLOCK_DIFF_IN_MS = clockDiff;
    }
    handleStartCalibration(data) {
        console.log("start calibration received", data);
        const startAt = data.args -
            (Date.now() + this.CLOCK_DIFF_IN_MS + this.voiceLatencyWithHostInMs);
        console.log("Should start at", startAt, data.args, Date.now(), this.CLOCK_DIFF_IN_MS, this.voiceLatencyWithHostInMs);
        // @ts-ignore
        window.webAudio.muteMic();
        setTimeout(playCalibrationSound, startAt);
    }
    handleLoadSharedVideo(data) {
        var _a;
        if (data.args.url == this.currentURL) {
            // do nothing
            return;
        }
        this.currentURL = data.args.url;
        console.log("handling load shared video?", data, this.videoElem, data.args.url);
        messageBroker_1.default.sendMessage({ percentage: 0, public_key: this.myId }, "anywhere--loading-video-status");
        // if the host has removed the video
        if (data.args.url == "") {
            (_a = document
                .querySelector("#viewportPlaceholderText")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
            if (this.videoElem) {
                this.videoElem.pause();
                this.videoElem.srcObject = null;
                this.videoElem.src = data.args.url;
            }
        }
        else {
            let placeholder = document.querySelector("#viewportPlaceholderText");
            let oldHTML = placeholder === null || placeholder === void 0 ? void 0 : placeholder.innerHTML;
            if (placeholder != null) {
                placeholder.innerHTML = "Loading video..." + 0 + "%";
                placeholder.style.fontSize = "3.5rem";
                placeholder.style.fontWeight = "bold";
                placeholder.style.color = "white";
                placeholder.classList.remove("hidden");
            }
            if (this.videoElem) {
                // preload video
                (0, video_preloader_1.default)(new URL(data.args.url), (percentage, loaded, total) => {
                    if (placeholder != null) {
                        placeholder.innerHTML = "Loading video..." + percentage + "%";
                        placeholder.style.fontSize = "3.5rem";
                        placeholder.style.fontWeight = "bold";
                        placeholder.style.color = "white";
                        placeholder.classList.remove("hidden");
                    }
                    messageBroker_1.default.sendMessage({ percentage, public_key: this.myId }, "anywhere--loading-video-status");
                }).then((blob) => {
                    let url = URL.createObjectURL(blob);
                    this.videoElem.srcObject = null;
                    this.videoElem.src = url;
                    if (placeholder != null) {
                        placeholder.classList.add("hidden");
                        placeholder.innerHTML = oldHTML;
                    }
                    this.videoElem.onloadeddata = async () => {
                        var _a;
                        messageBroker_1.default.sendMessage({ percentage: 100, public_key: this.myId }, "anywhere--loading-video-status");
                        (_a = this.videoElem) === null || _a === void 0 ? void 0 : _a.pause();
                    };
                });
            }
        }
    }
    handleRemoteGoTo(data) {
        const messageLatencyInMs = calculateMsgLatencyInMs(data.args.timestamp, this.CLOCK_DIFF_IN_MS);
        let totalLatencyInSeconds = (messageLatencyInMs + this.voiceLatencyWithHostInMs) / 1000;
        // guests shouldn't adjust for latency
        if (this.role === "guest" || data.args.bypass_latency)
            totalLatencyInSeconds = 0;
        let hostLatency = data.args.latency; // in seconds
        if (this.role === "guest" || data.args.bypass_latency)
            hostLatency = 0;
        console.log("Remote goto received, adjusting by %s, %s", totalLatencyInSeconds, trimmedMean(this.playLatencies));
        let newTime = data.args.seconds + hostLatency + totalLatencyInSeconds;
        if (data.args.bypass_latency == false) {
            newTime += trimmedMean(this.playLatencies); // add latency in seconds to play ahead of time
        }
        if (this.videoElem.paused == false) {
            // if the clip is playing
            if (this.videoElem)
                this.videoElem.currentTime = newTime; // do the skip
            console.warn("Playing after remote goto");
            // check after 3 seconds if the video is where it should be if not, seek again
            const checkAfter = 3;
            window.setTimeout(() => {
                if (this.videoElem.paused) {
                    // if it is currently pause then don't jump, this doesn't really make sense to me
                    // CHECK: if this is needed
                    return;
                }
                const diff = this.videoElem.currentTime - (newTime + checkAfter);
                if (Math.abs(diff) > 0.1 && Math.abs(diff) < checkAfter) {
                    console.warn("Should be seeking again, diff is %s", diff);
                    // if (this.videoElem) this.videoElem.currentTime = newTime + checkAfter
                }
            }, checkAfter * 1000);
        }
        else {
            if (this.role === "guest")
                newTime = data.args.seconds; // remove any latency
            if (this.videoElem)
                this.videoElem.currentTime = newTime;
        }
    }
    handleRemotePlay(data) {
        // correct for latency
        // We add messaging latency and voice latency (taken from the data channel)
        const messageLatencyInMs = calculateMsgLatencyInMs(data.args.timestamp, this.CLOCK_DIFF_IN_MS);
        let totalLatencyInSeconds = (messageLatencyInMs + this.voiceLatencyWithHostInMs) / 1000;
        console.log("latency is %s s, messageLatency: %s ms, voiceLatency: %s ms, medianPlayLatency :%s s", totalLatencyInSeconds, messageLatencyInMs, this.voiceLatencyWithHostInMs, trimmedMean(this.playLatencies));
        // guests have no latency compensation
        if (this.role === "guest" || data.args.bypass_latency)
            totalLatencyInSeconds = 0;
        // play now
        let latencyCompHostInSeconds = data.args.latency; // this is the latency of protools, the audio, the latency of the talent
        if (this.role != "talent" || data.args.bypass_latency)
            latencyCompHostInSeconds = 0;
        let latencyHTML = document.querySelector("#latency");
        if (latencyHTML) {
            latencyHTML.innerHTML = `msg: ${messageLatencyInMs}ms - clock: ${this.CLOCK_DIFF_IN_MS}ms - voice:${this.voiceLatencyWithHostInMs}ms - host: ${latencyCompHostInSeconds.toFixed(3)}s - player: ${trimmedMean(this.playLatencies).toFixed(3)}s`;
        }
        const playAt = data.args.seconds + totalLatencyInSeconds + latencyCompHostInSeconds;
        if (playAt >= 0) { // if the play at is more or equal to zero (usually)
            if (this.playbackTimeout)
                clearTimeout(this.playbackTimeout);
            // if video is not playing, play it
            if (this.videoElem) {
                this.videoElem.currentTime = playAt + trimmedMean(this.playLatencies);
                if (this.videoElem.paused == false) {
                    // its already playing, we don't need to do anything
                    return;
                }
                let pressingPlayAt = Date.now();
                this.videoElem.play().then(() => {
                    let diffInMs = Date.now() - pressingPlayAt;
                    if (diffInMs > 100)
                        console.warn("Playing is happening after %s ms", diffInMs);
                    // catch up to where we should be
                    this.playLatencies.push(diffInMs / 1000);
                    this.videoElem.currentTime += diffInMs / 1000;
                    // maybe we should add a checker after a few ms to see if it really is playing at the correct framerate
                    window.setTimeout(() => {
                        if (this.videoElem.paused) {
                            return;
                        }
                        let shouldBeAt = playAt + trimmedMean(this.playLatencies) + 1 + diffInMs / 1000;
                        let diffInSeconds = shouldBeAt - this.videoElem.currentTime;
                        console.log("Should be at", shouldBeAt, "is at", this.videoElem.currentTime, "diff", diffInSeconds);
                        this.playLatencies.push(diffInSeconds);
                        if (diffInSeconds > 0.05) {
                            this.videoElem.currentTime = shouldBeAt + diffInSeconds;
                        }
                    }, 1000);
                    window.setTimeout(() => {
                        if (this.videoElem.paused) {
                            return;
                        }
                        let shouldBeAt = playAt + trimmedMean(this.playLatencies) + 2 + diffInMs / 1000;
                        let diffInSeconds = shouldBeAt - this.videoElem.currentTime;
                        console.log("2 - Should be at", shouldBeAt, "is at", this.videoElem.currentTime, "diff", diffInSeconds);
                        if (diffInSeconds > 0.05) {
                            this.videoElem.currentTime = shouldBeAt + diffInSeconds;
                        }
                    }, 2000);
                });
            }
        }
        else {
            // play in the future
            if (this.videoElem)
                this.videoElem.currentTime = 0 + trimmedMean(this.playLatencies);
            if (this.playbackTimeout)
                clearTimeout(this.playbackTimeout);
            let now = Date.now();
            // note that the latency here the components are negative, this is because
            // 1) the seconds are negative
            // 2) the latency with host needs to be compensated for talent by setting it to play earlier
            //    thus, we need to negate the latency (that is always positive) so we play earlier
            let calculatedLatency = -data.args.seconds - latencyCompHostInSeconds - totalLatencyInSeconds;
            this.playbackTimeout = window.setTimeout(() => {
                var _a;
                console.log("Should play now, after", Date.now() - now, "ms", data.args.seconds + latencyCompHostInSeconds + totalLatencyInSeconds);
                if (this.videoElem) {
                    (_a = this.videoElem) === null || _a === void 0 ? void 0 : _a.play();
                }
            }, calculatedLatency * 1000);
        }
    }
    handleRemotePause(data) {
        if (this.videoElem) {
            this.videoElem.pause();
            if (data.args.bypass_latency) {
                this.videoElem.currentTime = data.args.seconds;
            }
            else {
                this.videoElem.currentTime = data.args.seconds + data.args.latency;
            }
        }
    }
}
exports.SlavePlayback = SlavePlayback;
let msgLatencies = [];
// get the latency between the timestamp and our local clock
function calculateMsgLatencyInMs(timestamp, clockDiffInMs) {
    const dateTimestamp = new Date(timestamp);
    let latency = Date.now() + clockDiffInMs - dateTimestamp.getTime();
    if (latency < 0) {
        console.error("Latency is negative, this is not possible, something is wrong", latency, timestamp, clockDiffInMs);
        return 0;
    }
    msgLatencies.push(latency);
    latency = median(msgLatencies);
    // should we decrease the delta_m here? as it takes some time?
    // apparently we shouldn't
    return latency;
}
function trimmedMean(values) {
    if (values.length === 0)
        return 0;
    values.sort(function (a, b) {
        return a - b;
    });
    // trim top 20% and bottom 20%
    const trim = Math.floor(values.length * 0.2);
    const trimmed = values.slice(trim, values.length - trim);
    return trimmed.reduce((a, b) => a + b, 0) / trimmed.length;
}
exports.trimmedMean = trimmedMean;
function median(values) {
    if (values.length === 0)
        return 0;
    values.sort(function (a, b) {
        return a - b;
    });
    var half = Math.floor(values.length / 2);
    if (values.length % 2)
        return values[half];
    else
        return (values[half - 1] + values[half]) / 2.0;
}
// NOTE: there is also a calibration sound in UI but its only for hosts...
// This one is for talent too.
function playCalibrationSound() {
    console.log("Play calibration sound for you");
    // ignore window error
    // @ts-ignore
    window.webAudio.playCalibrate();
}
let CLOCK_DIFF = 0; // this clock diff is set from the server
let CLOCK_DRIFT = 0; // the drift between our clock and the server's
let CLOCK_DELTA_M = 0; // 2 times the latency Server-client
function setClockDrift(clockDrift, sentAt) {
    CLOCK_DRIFT = clockDrift;
    CLOCK_DELTA_M = Date.now() - new Date(sentAt).getTime();
    CLOCK_DIFF = CLOCK_DRIFT - CLOCK_DELTA_M / 2;
    // console.log("Clock Drift", CLOCK_DRIFT,
    //             "Clock Delta", CLOCK_DELTA_M,
    //             "Clock DIFF", CLOCK_DIFF)
    return CLOCK_DIFF;
}
exports.setClockDrift = setClockDrift;
